import { useMemo } from 'react';

import { CartServiceMode, PosVendor, usePluConfigToVendorConfigAdapter } from '@rbilabs/intl-menu';

import { useFlag } from 'state/launchdarkly';
import { useServiceModeContext } from 'state/service-mode';
import { useStoreContext } from 'state/store';
import { LaunchDarklyFlag } from 'utils/launchdarkly';
import { PosVendors } from 'utils/vendor-config';

import usePosVendor from './menu/use-pos-vendor';

export const useConvertPluConfigs = () => {
  const { store } = useStoreContext();
  const { vendor } = usePosVendor();
  const { serviceMode } = useServiceModeContext();
  const enablePluConfigs = useFlag(LaunchDarklyFlag.ENABLE_PLU_CONFIGS);

  const posIntegration = store.integration?.partnerGroup?.posIntegration;

  const convertDeep = useMemo(() => {
    const isPartner = vendor === PosVendors.PARTNER;

    if (!(vendor && serviceMode && enablePluConfigs)) {
      return;
    }

    if (isPartner && !posIntegration) {
      return;
    }

    // eslint-disable-next-line react-hooks/rules-of-hooks
    return usePluConfigToVendorConfigAdapter(
      {
        posIntegration,
        posVendor: vendor as unknown as PosVendor,
        serviceMode: serviceMode as unknown as CartServiceMode,
      },
      {
        omitVendorConfigsType: true,
      }
    ).convertDeep;
  }, [posIntegration, vendor, serviceMode, enablePluConfigs]);

  return convertDeep;
};
